// NPM
import React, { useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// Services
import campaignService from "services/campaignService";

function FacebookButton() {
  // State
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const region = useSelector((state) => state.region.value);
  const facebookAppId = _.get(campaignConfig, `social.facebookAppId`);

  // Functions
  const loadFacebookSDK = () => {
    if (window.FB) {
      window.FB.init({
        appId: facebookAppId,
        xfbml: true,
        version: "v13.0",
      });
    } else {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: facebookAppId,
          xfbml: true,
          version: "v13.0",
        });
      };
    }
  };

  // Hooks
  useEffect(loadFacebookSDK, [facebookAppId]);

  if (_.isBlank(campaignConfig) || _.isBlank(region)) {
    return null;
  }

  const share = () => {
    const sharingHost = _.get(campaignConfig, `social.sharingHost`);
    const absoluteShareUrl = _.get(campaignConfig, `social.absoluteShareUrl`);

    const shareUrl = [
      sharingHost,
      "sharing",
      campaignService.getLanguageCode(),
      campaignService.getCampaignName(),
      "content",
      region,
    ].join("/");

    window.FB.ui({
      method: "feed",
      display: "popup",
      link: absoluteShareUrl || shareUrl,
    });
  };

  return (
    <button className="ShareButton FacebookButton" onClick={share}>
      <img src={require("images/facebook.png")} />
    </button>
  );
}

export default FacebookButton;
